import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';
import './FilterButton.scss';

const FilterButton = ({ filterList, defaultActive, onButtonClick }) => {
  const [active, setState] = useState(defaultActive);

  const setActive = (index) => {
    setState(index);
  };

  const getClass = (index) => {
    if (index === active) {
      return 'nw-button--filter--active';
    }
    return '';
  };

  const onFilterClick = (value, key) => {
    onButtonClick(value);
    setActive(key + 1);
  };

  return (
    <>
      <div className="nw-filter-buttons">
        {filterList.map((value, key) => (
          <div key={key} className="nw-filter-buttons__btn">
            <Button
              className={getClass(key + 1)}
              id={value}
              isFilter
              value={value}
              onButtonClick={() => onFilterClick(value, key)}
            />
          </div>
        ))}
      </div>
    </>
  );
};

FilterButton.propTypes = {
  // The list of filter
  filterList: PropTypes.arrayOf(PropTypes.string),
  // The default active filter button
  defaultActive: PropTypes.number,
  // The click event of filter button
  onButtonClick: PropTypes.func,
};

FilterButton.defaultProps = {
  filterList: ['3m', '6m', '12m', '3y', '5y'],
  defaultActive: 3,
  onButtonClick: () => {},
};


export default FilterButton;
